(function () {
    'use strict';

    angular
        .module('app')
        .factory('CostingService', CostingService);

    function CostingService($http, $q, WebAPIUrl) {

        var service = {
            getProtoCostingList: getProtoCostingList,
            updateProtoCosting: updateProtoCosting,
            uploadMassPrototypeCostingDocument: uploadMassPrototypeCostingDocument
        };

        return service;

        function getProtoCostingList(searchObject) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/Costing/GetProtoCostingList',
                data: searchObject,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function updateProtoCosting(costingData) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Costing/UpdateProtoCosting",
                data: costingData,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }


        function uploadMassPrototypeCostingDocument(file) {
            var deferred = $q.defer();

            var fd = new FormData();
            fd.append('file', file);
            $http.post(WebAPIUrl + "/api/Costing/UploadPrototypeCosting", fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }
    }

})();
